import { Grid } from "@mui/material";
import React from "react";
import HeaderSec from "../common/HeaderSec";
import HeroSlideshow from "./HeroSlideshow";
import Testimonials from "./Testimonials";
import Footer from "../common/Footer";
import Trataka from "./Trataka";
import ProjectsSection from "./ProjectsSection";
import Amenities from "./Amenities";
import ProjectVideoSection from "./ProjectVideoSection";
import GallerySection from "./GallerySection";
import OfficeLocation from "./OfficeLocation";
import MakeTheSwitch from "./MakeTheSwitch";
import AutoPopup from "./AutoPopup";

const HomePage = () => {
  return (
    <Grid>
      {/* <Header /> */}
      <HeaderSec />
      <HeroSlideshow />
      <Trataka />
      <MakeTheSwitch />
      <ProjectsSection />
      <ProjectVideoSection />
      <Amenities />
      <GallerySection />
      <OfficeLocation />
      <Testimonials />
      <Footer />
      <AutoPopup />
    </Grid>
  );
};

export default HomePage;
